import {
  ADD_CHAPTER_FAILURE,
  ADD_CHAPTER_REQUEST,
  ADD_CHAPTER_SUCCESS,
  GET_CHAPTERS_BY_MODULE_ID_FAILURE,
  GET_CHAPTERS_BY_MODULE_ID_REQUEST,
  GET_CHAPTERS_BY_MODULE_ID_SUCCESS,
  GET_CHAPTER_BY_ID_REQUEST,
  GET_CHAPTER_BY_ID_SUCCESS,
  GET_CHAPTER_BY_ID_FAILURE,
  DELETE_CHAPTER_REQUEST,
  DELETE_CHAPTER_SUCCESS,
  DELETE_CHAPTER_FAILURE,
  UPDATE_CHAPTER_REQUEST,
  UPDATE_CHAPTER_SUCCESS,
  UPDATE_CHAPTER_FAILURE,
  UPDATE_CHAPTER_ORDER_REQUEST,
  UPDATE_CHAPTER_ORDER_SUCCESS,
  UPDATE_CHAPTER_ORDER_FAILURE,
  REUPLOAD_VIDEO_INIT_REQUEST,
  REUPLOAD_VIDEO_INIT_SUCCESS,
  REUPLOAD_VIDEO_INIT_FAILURE,
  UPDATE_ARTICLE_REQUEST,
  UPDATE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_FAILURE,
  GET_ARTICLE_BY_CHAPTER_ID_REQUEST,
  GET_ARTICLE_BY_CHAPTER_ID_SUCCESS,
  GET_ARTICLE_BY_CHAPTER_ID_FAILURE,
  CLEAR_ARTICLE_CONTENT,
  DELETE_ARTICLE_REQUEST,
  DELETE_ARTICLE_SUCCESS,
  DELETE_ARTICLE_FAILURE,
  RESET_ADD_CHAPTER,
} from "./ActionType";

const initialState = {
  chapterListResponse: {},
  chapterByIdResponse: {},
  addChapterResult: {},
  updateChapterResult: {},
  reuploadVideoInitDetails: {},
  loading: false,
  error: null,
  updateOrderLoading: false,
  updateOrderError: null,
  updateChapterLoading: false,
  updateChapterError: null,
  reuploadVideoInitLoading: false,
  reuploadVideoInitError: null,
  updateArticleResult: {},
  updateArticleLoading: false,
  updateArticleError: null,
  articleByChapterId: "",
  articleByChapterIdLoading: false,
  articleByChapterIdError: null,
  deleteArticleResult: {},
  deleteArticleLoading: false,
  deleteArticleError: null,
};

export const chapterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHAPTERS_BY_MODULE_ID_REQUEST:
    case GET_CHAPTER_BY_ID_REQUEST:
    case ADD_CHAPTER_REQUEST:
    case DELETE_CHAPTER_REQUEST:
    case UPDATE_CHAPTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_CHAPTER_ORDER_REQUEST:
      return {
        ...state,
        updateOrderLoading: true,
        updateOrderError: null,
      };
    case GET_CHAPTERS_BY_MODULE_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        chapterListResponse: action.payload,
      };
    case GET_CHAPTER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        chapterByIdResponse: action.payload,
      };
    case UPDATE_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        updateChapterResult: action.payload,
      };
    case GET_CHAPTERS_BY_MODULE_ID_FAILURE:
    case GET_CHAPTER_BY_ID_FAILURE:
    case ADD_CHAPTER_FAILURE:
    case DELETE_CHAPTER_FAILURE:
    case UPDATE_CHAPTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_CHAPTER_ORDER_FAILURE:
      return {
        ...state,
        updateOrderLoading: false,
        updateOrderError: action.payload,
      };
    case ADD_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        addChapterResult: action.payload,
      };
    case DELETE_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        chapterListResponse: {
          ...state.chapterListResponse,
          chapters: state.chapterListResponse.chapters?.filter(
            (chapter) => chapter.id !== action.payload
          ) || [],
        },
      };
    case UPDATE_CHAPTER_ORDER_SUCCESS:
      return {
        ...state,
        updateOrderLoading: false,
        updateOrderError: null,
      };

    // Reupload Video Init Cases
    case REUPLOAD_VIDEO_INIT_REQUEST:
      return {
        ...state,
        reuploadVideoInitLoading: true,
        reuploadVideoInitError: null,
      };

    case REUPLOAD_VIDEO_INIT_SUCCESS:
      return {
        ...state,
        reuploadVideoInitLoading: false,
        reuploadVideoInitError: null,
        reuploadVideoInitDetails: action.payload,
      };

    case REUPLOAD_VIDEO_INIT_FAILURE:
      return {
        ...state,
        reuploadVideoInitLoading: false,
        reuploadVideoInitError: action.payload,
      };

    // Update Article Cases
    case UPDATE_ARTICLE_REQUEST:
      return {
        ...state,
        updateArticleLoading: true,
        updateArticleError: null,
      };

    case UPDATE_ARTICLE_SUCCESS:
      return {
        ...state,
        updateArticleLoading: false,
        updateArticleError: null,
        updateArticleResult: action.payload,
      };

    case UPDATE_ARTICLE_FAILURE:
      return {
        ...state,
        updateArticleLoading: false,
        updateArticleError: action.payload,
      };

    // Get Article by Chapter ID Cases
    case GET_ARTICLE_BY_CHAPTER_ID_REQUEST:
      return {
        ...state,
        articleByChapterIdLoading: true,
        articleByChapterIdError: null,
      };

    case GET_ARTICLE_BY_CHAPTER_ID_SUCCESS:
      return {
        ...state,
        articleByChapterIdLoading: false,
        articleByChapterIdError: null,
        articleByChapterId: action.payload,
      };

    case GET_ARTICLE_BY_CHAPTER_ID_FAILURE:
      return {
        ...state,
        articleByChapterIdLoading: false,
        articleByChapterIdError: action.payload,
      };

    case CLEAR_ARTICLE_CONTENT:
      return {
        ...state,
        articleByChapterId: "",
        articleByChapterIdError: null,
      };

    // Delete Article Cases
    case DELETE_ARTICLE_REQUEST:
      return {
        ...state,
        deleteArticleLoading: true,
        deleteArticleError: null,
      };

    case DELETE_ARTICLE_SUCCESS:
      return {
        ...state,
        deleteArticleLoading: false,
        deleteArticleError: null,
        deleteArticleResult: action.payload,
      };

    case DELETE_ARTICLE_FAILURE:
      return {
        ...state,
        deleteArticleLoading: false,
        deleteArticleError: action.payload,
      };

    case RESET_ADD_CHAPTER:
      return {
        ...state,
        addChapterResult: {},
        error: null,
      };

    default:
      return state;
  }
};
